import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'component-start-treatment',
  templateUrl: './start-treatment.component.html',
  styleUrls: ['./start-treatment.component.css','../../../styles.scss']
})
export class StartTreatmentComponent implements OnInit {
  constructor(protected route:ActivatedRoute,
    @Inject(DOCUMENT) private document:Document,
    @Inject(PLATFORM_ID) private platformId: Object) { }
  @Input() imgBackground:string = "assets/imgs/endBG_content_landing_lg.jpg";
  protected iparam:string|null=null;
  protected referalCode:string=this.getCookie('referenceBhavani');
  platformBaseUrl = $localize.locale ==='es'? `https://my.bhavani.app/es/`: `https://my.bhavani.app/en/`
  @Input() customEndpoint: string = '';
  private getCookie(name: string) {
    if (!isPlatformBrowser(this.platformId)) return '';
    let ca: Array<string> = this.document.cookie.split(';');
    let caLen: number = ca.length;
    let cookieName = `${name}=`;
    let c: string;

    for (let i: number = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, '');
      if (c.indexOf(cookieName) == 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return '';
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if(params['i']) params['i'] === '1' ? this.iparam=params['i'] : this.iparam='0';
    });
  }

}
